import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import SplashCursor from '../components/Animations/SplashCursor'

export default function LayoutMain({ children }) {
  return (
    <>
      <SplashCursor />
      <Navbar />
      {children}
      <Footer />
    </>
  )
}
